export enum IdentityProvider {
	MICROSOFT = 'microsoft',
	GOOGLE = 'google',
}

export enum LinkedAccountStatus {
	WAITING = 'waiting',
	READY = 'ready',
}

export enum LinkedAccountReauthRequiredReason {
	TOKEN_EXPIRED = 'token_expired',
	CALENDAR_ACCESS_DENIED = 'calendar_access_denied',
}

export type LinkedAccount = {
	id: number;
	uuid: string;
	primaryAccount: boolean;
	provider: IdentityProvider;
	status: LinkedAccountStatus;
	email: string;
	createdAt: Date;
	info?: {
		calendarAccess: boolean;
	};

	reauthRequired: boolean;
	reauthRequiredReason?: LinkedAccountReauthRequiredReason | null;

	// prepared
	calendarAccess?: boolean;
};
